const TAX_SUMMARY_RATES = [21, 7];
const REDUCED_TAX_TARIFF_GROUP = '680003';
const DEFAULT_TAX_SUMMARY_PRECISION = 2;

const toFiniteNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const firstFiniteNumber = (...values) => {
  for (const value of values) {
    const number = toFiniteNumber(value);
    if (number !== null) return number;
  }

  return null;
};

const roundMoney = (value, precision = DEFAULT_TAX_SUMMARY_PRECISION) => {
  const factor = 10 ** precision;
  return Math.round((Number(value || 0) + Number.EPSILON) * factor) / factor;
};

const getTaxRateByTariffGroup = (item) => {
  const tariffGroup = `${item?.tarifnaGrupa ?? item?.tarifnagrupa ?? ''}`;
  return tariffGroup === REDUCED_TAX_TARIFF_GROUP ? 7 : 21;
};

export const calculateCartTaxSummary = ({
  cart,
  cartUsesGrossPrices,
  getCartItemDiscountedPrice,
  precision = DEFAULT_TAX_SUMMARY_PRECISION,
}) => {
  const netByRate = TAX_SUMMARY_RATES.reduce(
    (acc, rate) => ({ ...acc, [rate]: 0 }),
    {},
  );
  const grossByRate = TAX_SUMMARY_RATES.reduce(
    (acc, rate) => ({ ...acc, [rate]: 0 }),
    {},
  );

  (cart || []).forEach((item) => {
    const quantity = Number(item?.quantity || 0);
    if (!(quantity > 0)) return;

    const knownNetUnit = firstFiniteNumber(item?.krajnjaCenaBezPDV);
    const knownGrossUnit = firstFiniteNumber(item?.krajnjaCenaSaPDV);
    const hasNetAndGross = knownNetUnit !== null && knownGrossUnit !== null;
    const fallbackUnitPrice = Number(getCartItemDiscountedPrice(item) || 0);

    let netUnit;
    let grossUnit;
    const taxRate = getTaxRateByTariffGroup(item);

    if (hasNetAndGross) {
      netUnit = knownNetUnit;
      grossUnit = knownGrossUnit;
    } else if (cartUsesGrossPrices) {
      grossUnit = fallbackUnitPrice;
      netUnit = taxRate > 0 ? grossUnit / (1 + taxRate / 100) : grossUnit;
    } else {
      netUnit = fallbackUnitPrice;
      grossUnit = netUnit * (1 + taxRate / 100);
    }

    if (netByRate[taxRate] === undefined) netByRate[taxRate] = 0;
    if (grossByRate[taxRate] === undefined) grossByRate[taxRate] = 0;
    netByRate[taxRate] += netUnit * quantity;
    grossByRate[taxRate] += grossUnit * quantity;
  });

  let grossTotal = 0;
  let netTotal = 0;
  const taxByRate = {};

  Object.keys(grossByRate).forEach((rate) => {
    const roundedNet = roundMoney(netByRate[rate], precision);
    const roundedGross = roundMoney(grossByRate[rate], precision);
    netTotal += roundedNet;
    grossTotal += roundedGross;
    taxByRate[rate] = roundMoney(roundedGross - roundedNet, precision);
  });

  return {
    grossTotal: roundMoney(grossTotal, precision),
    netTotal: roundMoney(netTotal, precision),
    taxByRate,
    rates: TAX_SUMMARY_RATES,
  };
};
